import { render, staticRenderFns } from "./AppItemDetails.vue?vue&type=template&id=7bb46426&scoped=true&"
import script from "./AppItemDetails.vue?vue&type=script&lang=ts&"
export * from "./AppItemDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AppItemDetails.vue?vue&type=style&index=0&id=7bb46426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb46426",
  null
  
)

export default component.exports